import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataPreviewInfo } from '../../../models/rest/requestparameters';
import { DataPreviewService } from '../../../services/data.preview.service';

@Component({
    selector: 'container-column-dialog',
    templateUrl: './containerview.column.dialog.html',
    styleUrls: ['./containerview.column.dialog.css']
})
export class ContainerColumnDialog implements OnInit {

    Args: ContainerColumnDialogArgs;
    AllColumns = [];
    StructureOptions = [];
    Sort = 0;

    constructor(private preview: DataPreviewService, private cdRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        if (this.Args && this.Args.DataSourceId && this.Args.PreviewInfo) {
            this.preview.GetStructureWithOptions(this.Args.DataSourceId, this.Args.PreviewInfo).subscribe((result) => {
                if (result) {
                    if (result.Structure) {
                        result.Structure.forEach((col, i) => {
                            col.ColSelected = true;
                            col.ColVisible = true;
                            col.SortIndex = i;
                            col.SortName = col.Name.toLowerCase();
                        });
                        this.AllColumns = result.Structure;
                    }
                    if (result.Options) {
                        this.StructureOptions = result.Options;
                    }
                }
                this.cdRef.detectChanges();
            });
        }
    }

    Initialize(args) {
        this.Args = args;
    }

    GetDialogResult() {
        var selCols = [];
        this.AllColumns.forEach((col) => {
            if (col.ColSelected && col.ColVisible) {
                delete col.ColSelected;
                delete col.ColVisible;
                delete col.SortIndex;
                delete col.SortName;
                selCols.push(col);
            }
        });
        return {
            SelectedColumns: selCols,
            Options: this.StructureOptions
        };
    }

    hideUsedChanged(ev) {
        if (typeof ev === 'boolean') {
            if (ev) {
                if (this.Args) {
                    var fields = this.Args.Fields;
                    if (fields && fields.length > 0) {
                        this.AllColumns.forEach((col) => {
                            if (fields.some(f => f.Name == col.Name && f.DataTyp == col.DataTyp)) {
                                col.ColVisible = false;
                            }
                        });
                    }
                }
            } else {
                this.AllColumns.forEach((col) => {
                    col.ColVisible = true;
                });
            }
        }
    }

    selectAllChanged(ev) {
        if (typeof ev === 'boolean') {
            this.AllColumns.forEach((col) => {
                col.ColSelected = ev;
            });
        }
    }

    changeSort() {
        if (this.Sort == 0) { // NoSort -> ASC
            this.Sort = 1;
            this.AllColumns.sort((a, b) => {
                const aVal = a.SortName;
                const bVal = b.SortName;
                if (aVal < bVal) {
                    return -1;
                }
                if (aVal > bVal) {
                    return 1;
                }
                return 0;
            });
        } else if (this.Sort == 1) { // ASC -> DESC
            this.Sort = 2;
            this.AllColumns.reverse();
        } else { // DESC -> NoSort
            this.Sort = 0;
            this.AllColumns.sort((a, b) => {
                return a.SortIndex - b.SortIndex;
            });
        }
        this.cdRef.detectChanges();
    }
}

export class ContainerColumnDialogArgs {
    DataSourceId: string;
    PreviewInfo: DataPreviewInfo;
    Fields: any[] = [];
}
